/**
 * Desktop Clubs / Nations mega-menu, reworked as full-width tabs:
 *   - top row = the 2nd-level items (leagues / continents) as tabs
 *   - below = the active tab's 3rd-level links (clubs / countries) spread across
 *     the FULL width in ~170px columns, so it stays short (no crop / no scroll).
 * Hover or click a tab to switch. Independent of the theme's column markup.
 * Reversible: remove this script (+ its <script> line in layout/theme.liquid).
 */
(function () {
  const CSS = `
  /* main top-nav links were tiny next to the submenu — bump them on desktop */
  @media (min-width:990px){
    .menu-list__link { font-size:1.25rem !important; }
    .menu-list__link .menu-list__link-title { font-size:inherit !important; }
  }
  /* let the dropdown grow to fit its content (kills the cropped/scrolling panel) */
  .menu-list__submenu:has(.mm-tabbed),
  .menu-list__submenu:has(.mm-tabbed) .menu-list__submenu-inner,
  .menu-list__submenu:has(.mm-tabbed) .mega-menu,
  .menu-list__submenu:has(.mm-tabbed) .mega-menu__grid { max-height:none !important; height:auto !important; overflow:visible !important; }
  .menu-list__submenu:has(.mm-tabbed) .mega-menu { padding:6px 0 14px !important; }

  .mega-menu__list.mm-tabbed { display:block !important; min-height:0 !important; width:100%; }
  .mega-menu__list.mm-tabbed > .mega-menu__column { display:none !important; }
  .mega-menu__list.mm-tabbed img, .mega-menu__list.mm-tabbed picture { display:none !important; }

  .mm-tabs { display:flex; flex-wrap:wrap; gap:0 30px; padding:6px 30px; border-bottom:1px solid rgba(128,128,128,.18); }
  .mm-tabs .mm-tab {
    background:none; border:0; border-bottom:2px solid transparent; color:inherit; cursor:pointer;
    font-family:inherit; font-weight:600; font-size:1.4rem; line-height:1.25; padding:13px 2px;
    text-transform:none; letter-spacing:0; -webkit-font-smoothing:antialiased;
  }
  .mm-tabs .mm-tab:not(.mm-active) { opacity:.6; }
  .mm-tabs .mm-tab.mm-active { opacity:1; border-bottom-color:currentColor; }

  .mm-panel { padding:16px 30px 20px; }
  .mm-panel .mm-kids { columns:200px; column-gap:34px; }
  .mm-panel .mm-kids .mega-menu__link {
    display:block; padding:7px 2px; font-size:1.15rem; font-weight:400; opacity:.92;
    break-inside:avoid; text-transform:none; -webkit-font-smoothing:antialiased;
  }
  `;

  function injectCss() {
    if (document.getElementById('mm-accordion-css')) return;
    const s = document.createElement('style');
    s.id = 'mm-accordion-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // The theme reveals the dropdown with a clip-path/translate sized by
  // --submenu-height (measured offsetHeight). Our dynamic tab content changes
  // height, so we recompute it ourselves to avoid the panel being clipped.
  function fitSubmenu(list) {
    const submenu = list.closest('.menu-list__submenu');
    const header = list.closest('header-component') || document.querySelector('header-component');
    if (!submenu || !header) return;
    requestAnimationFrame(() => {
      const h = submenu.offsetHeight;
      if (h > 0) header.style.setProperty('--submenu-height', h + 'px');
    });
  }

  function enhance(list) {
    if (list.dataset.mmDone === '1') return;
    const links = Array.from(list.querySelectorAll('.mega-menu__link'));
    const parents = links.filter((a) => a.classList.contains('mega-menu__link--parent'));
    if (!parents.length) return; // only 3-level menus (Clubs / Nations)
    list.dataset.mmDone = '1';
    list.classList.add('mm-tabbed');

    // group links in document order: each parent (league/continent) + its children
    const groups = [];
    let cur = null;
    for (const a of links) {
      if (a.classList.contains('mega-menu__link--parent')) { cur = { header: a, kids: [] }; groups.push(cur); }
      else if (cur) { cur.kids.push(a); }
    }

    const tabs = document.createElement('div');
    tabs.className = 'mm-tabs';
    const panel = document.createElement('div');
    panel.className = 'mm-panel';

    groups.forEach((g, idx) => {
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'mm-tab';
      tab.textContent = (g.header.textContent || '').trim();
      const kidsBox = document.createElement('div');
      kidsBox.className = 'mm-kids';
      kidsBox.hidden = true;
      g.kids.forEach((a) => kidsBox.appendChild(a));
      g.tab = tab;
      g.box = kidsBox;
      const activate = () => {
        groups.forEach((gg, j) => {
          gg.tab.classList.toggle('mm-active', j === idx);
          gg.box.hidden = j !== idx;
        });
        fitSubmenu(list);
      };
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); activate(); });
      tabs.appendChild(tab);
      panel.appendChild(kidsBox);
    });

    // open the first tab by default
    if (groups[0]) { groups[0].tab.classList.add('mm-active'); groups[0].box.hidden = false; }

    list.querySelectorAll(':scope > .mega-menu__column').forEach((c) => { c.style.display = 'none'; });
    list.appendChild(tabs);
    list.appendChild(panel);
    fitSubmenu(list);
    // re-measure when the menu is actually opened/hovered (theme may overwrite)
    const item = list.closest('.menu-list__list-item');
    if (item) item.addEventListener('pointerenter', () => fitSubmenu(list));
  }

  function run() {
    injectCss();
    document.querySelectorAll('.mega-menu__list').forEach(enhance);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  let rz;
  window.addEventListener('resize', () => {
    clearTimeout(rz);
    rz = setTimeout(() => document.querySelectorAll('.mega-menu__list.mm-tabbed').forEach(fitSubmenu), 150);
  });

  const mo = new MutationObserver(() => document.querySelectorAll('.mega-menu__list:not([data-mm-done="1"])').forEach(enhance));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
